import { useState } from "react";
import Topbar from "../components/layout/Topbar.jsx";
import { Modal, ProgressBar } from "../components/ui/index.jsx";

const CONTRACTS = [
  { id:"ct1", company:"ACME Corp",     type:"FORFAIT",  amount:450,  hours:20, used:14, start:"01/01/2024", end:"31/12/2025", status:"active" },
  { id:"ct2", company:"Dupont SA",     type:"HORAIRE",  amount:0,    rate:150, start:"01/03/2024", end:"28/02/2026", status:"active" },
  { id:"ct3", company:"Martin & Co",   type:"FORFAIT",  amount:350,  hours:10, used:4,  start:"01/02/2024", end:"31/01/2026", status:"active" },
  { id:"ct4", company:"Bertrand Inc",  type:"MIXTE",    amount:600,  hours:15, used:11, start:"01/04/2024", end:"31/03/2026", status:"active" },
  { id:"ct5", company:"Tech Solutions",type:"FORFAIT",  amount:250,  hours:8,  used:8,  start:"01/01/2023", end:"31/12/2023", status:"expired" },
];
const INVOICES = [
  { id:"INV-2025-042", company:"ACME Corp",    period:"Avril 2025",  amountHT:450,  tva:90,   status:"PAID",    paidAt:"05/05/2025" },
  { id:"INV-2025-041", company:"Dupont SA",    period:"Avril 2025",  amountHT:1275, tva:255,  status:"PENDING", paidAt:null },
  { id:"INV-2025-040", company:"Martin & Co",  period:"Avril 2025",  amountHT:350,  tva:70,   status:"PAID",    paidAt:"03/05/2025" },
  { id:"INV-2025-039", company:"Bertrand Inc", period:"Avril 2025",  amountHT:600,  tva:120,  status:"OVERDUE", paidAt:null },
  { id:"INV-2025-038", company:"ACME Corp",    period:"Mars 2025",   amountHT:450,  tva:90,   status:"PAID",    paidAt:"04/04/2025" },
  { id:"INV-2025-037", company:"Dupont SA",    period:"Mars 2025",   amountHT:1050, tva:210,  status:"PAID",    paidAt:"06/04/2025" },
];

export default function BillingPage() {
  const [activeTab, setActiveTab] = useState("invoices");
  const [showContractModal, setShowContractModal] = useState(false);

  const totalRevenueMois = INVOICES.filter(i => i.period === "Avril 2025").reduce((s,i) => s + i.amountHT, 0);
  const unpaidCount = INVOICES.filter(i => i.status === "PENDING" || i.status === "OVERDUE").length;

  return (
    <>
      <Topbar title="Facturation &" subtitle="contrats"/>
      <div className="page-body">
        <div className="page-header">
          <div>
            <div className="page-title">Facturation & <span>contrats</span></div>
            <div className="page-sub">{unpaidCount} facture{unpaidCount > 1 ? "s" : ""} en attente de paiement</div>
          </div>
          <div className="page-actions">
            <button className="btn-itm btn-itm-outline" onClick={() => setShowContractModal(true)}>
              <i className="bi bi-file-earmark-plus" /> Nouveau contrat
            </button>
            <button className="btn-itm btn-itm-primary">
              <i className="bi bi-receipt" /> Générer les factures
            </button>
          </div>
        </div>

        {/* Métriques facturation */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:14, marginBottom:20 }}>
          {[
            { icon:"bi-cash-stack",     color:"green",  label:"CA ce mois",         value:`${totalRevenueMois.toLocaleString("fr")} €` },
            { icon:"bi-exclamation-circle",color:"orange",label:"Factures impayées", value:`${unpaidCount}` },
            { icon:"bi-file-earmark-check",color:"teal",label:"Contrats actifs",    value:`${CONTRACTS.filter(c=>c.status==="active").length}` },
            { icon:"bi-clock-history",  color:"purple", label:"Contrats expirant",  value:"1" },
          ].map((m,i)=>(
            <div key={i} className={`metric-card mc-${m.color} anim-fade-up`} style={{animationDelay:`${.05+i*.05}s`}}>
              <div className="metric-glow"/>
              <div className="metric-icon"><i className={`bi ${m.icon}`}/></div>
              <div className="metric-label">{m.label}</div>
              <div style={{fontFamily:"Syne,sans-serif",fontSize:26,fontWeight:800,color:"var(--text-1)",lineHeight:1}}>{m.value}</div>
            </div>
          ))}
        </div>

        {/* Onglets */}
        <div className="itm-tabs">
          {[{id:"invoices",label:"Factures"},{id:"contracts",label:"Contrats"},{id:"hours",label:"Suivi heures"}].map(t=>(
            <div key={t.id} className={`itm-tab ${activeTab===t.id?"active":""}`} onClick={()=>setActiveTab(t.id)}>{t.label}</div>
          ))}
        </div>

        {/* Factures */}
        {activeTab === "invoices" && (
          <div className="itm-card anim-fade-up">
            <table className="itm-table">
              <thead><tr><th>Numéro</th><th>Client</th><th>Période</th><th>Montant HT</th><th>TVA</th><th>TTC</th><th>Statut</th><th>Actions</th></tr></thead>
              <tbody>
                {INVOICES.map(inv => (
                  <tr key={inv.id}>
                    <td style={{fontFamily:"monospace",fontSize:12,color:"var(--text-3)"}}>{inv.id}</td>
                    <td className="cell-primary">{inv.company}</td>
                    <td style={{color:"var(--text-2)"}}>{inv.period}</td>
                    <td style={{fontFamily:"Syne,sans-serif",fontWeight:600,color:"var(--text-1)"}}>{inv.amountHT.toLocaleString("fr")} €</td>
                    <td style={{color:"var(--text-3)"}}>{inv.tva} €</td>
                    <td style={{fontFamily:"Syne,sans-serif",fontWeight:700,color:"var(--text-1)"}}>{(inv.amountHT+inv.tva).toLocaleString("fr")} €</td>
                    <td>
                      <span className={`badge-status ${inv.status==="PAID"?"bs-paid":inv.status==="OVERDUE"?"bs-overdue":"bs-pending-pay"}`}>
                        {inv.status==="PAID"?"Payée":inv.status==="OVERDUE"?"En retard":"En attente"}
                      </span>
                    </td>
                    <td>
                      <div style={{display:"flex",gap:6}}>
                        <button className="btn-icon-sm" title="PDF"><i className="bi bi-file-earmark-pdf"/></button>
                        <button className="btn-icon-sm" title="Envoyer"><i className="bi bi-envelope"/></button>
                        {inv.status!=="PAID" && <button className="btn-icon-sm" title="Marquer payée" style={{color:"var(--success)"}}><i className="bi bi-check-circle"/></button>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Contrats */}
        {activeTab === "contracts" && (
          <div className="itm-card anim-fade-up">
            <table className="itm-table">
              <thead><tr><th>Client</th><th>Type</th><th>Montant</th><th>Début</th><th>Fin</th><th>Statut</th><th>Actions</th></tr></thead>
              <tbody>
                {CONTRACTS.map(c=>(
                  <tr key={c.id}>
                    <td className="cell-primary">{c.company}</td>
                    <td><span className="badge-status bs-active">{c.type}</span></td>
                    <td style={{fontFamily:"Syne,sans-serif",fontWeight:700,color:"var(--text-1)"}}>
                      {c.type==="HORAIRE" ? `${c.rate} €/h` : `${c.amount} €/mois`}
                    </td>
                    <td style={{fontSize:12,color:"var(--text-3)"}}>{c.start}</td>
                    <td style={{fontSize:12,color:"var(--text-3)"}}>{c.end}</td>
                    <td><span className={`badge-status ${c.status==="active"?"bs-active":"bs-inactive"}`}>{c.status==="active"?"Actif":"Expiré"}</span></td>
                    <td>
                      <div style={{display:"flex",gap:6}}>
                        <button className="btn-icon-sm"><i className="bi bi-pencil"/></button>
                        <button className="btn-icon-sm"><i className="bi bi-files"/></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Suivi heures */}
        {activeTab === "hours" && (
          <div className="itm-card anim-fade-up">
            <div className="card-title-row"><div className="card-title">Consommation des forfaits</div><div className="card-sub">Ce mois-ci</div></div>
            <div style={{display:"flex",flexDirection:"column",gap:16}}>
              {CONTRACTS.filter(c=>c.hours).map(c=>{
                const pct = Math.round((c.used/c.hours)*100);
                return (
                  <div key={c.id}>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                      <span style={{fontWeight:500,color:"var(--text-1)",fontSize:13}}>{c.company}</span>
                      <span style={{fontFamily:"Syne,sans-serif",fontWeight:700,color:"var(--text-1)",fontSize:13}}>{c.used}h / {c.hours}h</span>
                    </div>
                    <ProgressBar value={c.used} max={c.hours} color={pct>=80?"var(--danger)":pct>=60?"var(--warning)":"var(--accent)"} />
                    <div style={{fontSize:11,color: pct>=80?"var(--danger)":"var(--text-3)",marginTop:4}}>{pct}% · {c.hours-c.used}h restantes</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Modal nouveau contrat */}
        {showContractModal && (
          <Modal title="Nouveau contrat" onClose={() => setShowContractModal(false)}
            footer={<>
              <button className="btn-itm btn-itm-outline" onClick={() => setShowContractModal(false)}>Annuler</button>
              <button className="btn-itm btn-itm-primary" onClick={() => setShowContractModal(false)}>
                <i className="bi bi-file-earmark-check" /> Créer le contrat
              </button>
            </>}
          >
            <div className="form-group">
              <label className="itm-label">Client</label>
              <select className="itm-select" style={{width:"100%"}}>
                {CONTRACTS.map(c=><option key={c.id} value={c.company}>{c.company}</option>)}
              </select>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="itm-label">Type de contrat</label>
                <select className="itm-select" style={{width:"100%"}}>
                  <option>FORFAIT</option><option>HORAIRE</option><option>MIXTE</option>
                </select>
              </div>
              <div className="form-group">
                <label className="itm-label">Montant mensuel (€)</label>
                <input className="itm-input" type="number" placeholder="450" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="itm-label">Heures incluses</label>
                <input className="itm-input" type="number" placeholder="20" />
              </div>
              <div className="form-group">
                <label className="itm-label">Taux horaire hors forfait (€)</label>
                <input className="itm-input" type="number" placeholder="150" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="itm-label">Date de début</label>
                <input className="itm-input" type="date" />
              </div>
              <div className="form-group">
                <label className="itm-label">Date de fin</label>
                <input className="itm-input" type="date" />
              </div>
            </div>
            <label style={{display:"flex",alignItems:"center",gap:8,fontSize:13,color:"var(--text-2)",cursor:"pointer"}}>
              <input type="checkbox" defaultChecked /> Renouvellement automatique
            </label>
          </Modal>
        )}
      </div>
    </>
  );
}
